module.exports = __webpack_public_path__ + "static/media/la_candela_logo.09e15ae8.png";